export default "__VITE_ASSET__af73a334__"